import { __rest as e } from "tslib";
import a from "classnames";
import { Root as t, List as r, Content as n, Trigger as s } from "@radix-ui/react-tabs";
import * as l from "react";
import { ComponentClassNames as i } from "../shared/constants.js";
import { Flex as o } from "../Flex/Flex.js";
import { View as c } from "../View/View.js";

var m = function m(e) {
  return null !== e && "object" == typeof e && e.hasOwnProperty("props") && null != e.props.title;
},
    p = l.forwardRef(function (s, c) {
  var p = s.ariaLabel,
      d = s.children,
      f = s.className,
      _s$defaultIndex = s.defaultIndex,
      u = _s$defaultIndex === void 0 ? 0 : _s$defaultIndex,
      b = s.currentIndex,
      g = s.onChange,
      h = s.indicatorPosition,
      y = s.spacing,
      x = e(s, ["ariaLabel", "children", "className", "defaultIndex", "currentIndex", "onChange", "indicatorPosition", "spacing"]);
  var I = l.Children.map(d, function (e) {
    return null === e || "string" == typeof e && /\s/.test(e) ? {} : m(e) ? e.props : (console.warn("Amplify UI: <Tabs> component only accepts <TabItem> as children."), {});
  }),
      N = {
    defaultValue: u.toString(),
    value: null != b ? b.toString() : void 0,
    onValueChange: g
  };
  return l.createElement(t, Object.assign({}, N), l.createElement(r, {
    "aria-label": p
  }, l.createElement(o, Object.assign({
    className: a(i.Tabs, f),
    "data-indicator-position": h,
    ref: c
  }, x), l.Children.map(d, function (e, a) {
    return m(e) ? l.cloneElement(e, {
      "data-spacing": y,
      key: a,
      value: "".concat(a)
    }) : null;
  }))), I.map(function (e, a) {
    return l.createElement(n, {
      key: a,
      value: "".concat(a)
    }, e.children);
  }));
}),
    d = l.forwardRef(function (t, r) {
  var n = t.className,
      o = t.title,
      m = e(t, ["className", "title"]);
  return l.createElement(c, Object.assign({
    as: s,
    className: a(i.TabItems, n),
    ref: r
  }, m), o);
});

p.displayName = "Tabs", d.displayName = "TabItem";
export { d as TabItem, p as Tabs };